<div class="flex flex-justify-between flex-middle bg-col-51 p-a-3 b-radius-4"
     style="max-height: 48px;"
     [class.is-busy]="status?.busy">
    <button class="col-1 p-l-1 p-r-1 flex flex-middle"
            [ngClass]="{'is-disable col-4': !canLess() || status?.busy}"
            [attr.aria-label]="'Remove one item' | translate"
            (click)="less()"
            cy-decreasequantity>
        <i class="icon-minus qty-icon flex flex-middle"
           aria-hidden="true"></i>
    </button>

    <div class="pos-relative">
        <!-- loader -->
        @if (status?.busy) {
        <div class="fill flex flex-middle flex-justify-center">
            <i class="icon-loading"></i>
        </div>
        }

        <input class="no-spinner center s1 m-t-1 m-b-1 qty-input"
               type="number"
               step="1"
               [disabled]="status?.busy || (!canMore() && !canLess()) "
               [attr.min]="min || null"
               cy-quantityinput
               #input
               [(ngModel)]="model"
               (blur)="validate()"
               [minWidth]="18.2"
               autoSizeInput>
    </div>

    <button class="col-1 p-l-1 p-r-1 flex flex-middle"
            [ngClass]="{'is-disable col-4': !canMore() || status?.busy}"
            [attr.aria-label]="'Add one item' | translate"
            (click)="more()"
            cy-increasequantity>
        <i class="icon-plus qty-icon flex flex-middle"
           aria-hidden="true"></i>
    </button>
</div>
